import { useLingui } from '@lingui/react/macro';
import { Accept } from 'react-dropzone';
import { formatBytes } from 'shared/utils/format-bytes';
import { theme } from 'styles/theme/theme';
import { UDText } from 'ud-ui/components';
import { describeFormats } from '../domain/accepted-formats';

interface DropzoneHintProps {
  accept: Accept;
  maxSize: number;
}

/**
 * Подпись под зоной.
 *
 * Строится из тех же `accept` и `maxSize`, что уходят в `react-dropzone`, и
 * поэтому не может разойтись с тем, что поле принимает на самом деле. Прежняя
 * подпись была захардкожена — обещала «png, jpg», умалчивая и про webp, и про
 * предел размера, из-за которого файл могли молча не принять.
 */
export function DropzoneHint({ accept, maxSize }: DropzoneHintProps) {
  const { t } = useLingui();
  const formats = describeFormats(accept);
  const size = formatBytes(maxSize);

  return (
    <UDText type="caption-1" color={theme.colors.SurfaceRomanSilver30}>
      {t`Формат: ${formats} · до ${size}`}
    </UDText>
  );
}
